import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "utils/toast";
import { useProduct } from "contexts/ProductContext";
import { useProductActions } from "hooks/useProductActions";
import { getActionsByType } from "integrations/firebase/collections";
import { actionInProgress } from "utils/status";

export const useKeywordGeneration = () => {
  const { t } = useTranslation(["components"]);
  const { product } = useProduct();
  const { generateProductKeywords, errorUpdate, errorGenerate } =
    useProductActions();

  const { keywords: keywordsActions } = getActionsByType(product);
  const isGenerating = actionInProgress(keywordsActions?.generate);

  const generateKeywords = useCallback(
    async (options?: { regenerate?: boolean }) => {
      if (!product) return false;

      const success = await generateProductKeywords(product, options);

      if (success) {
        toast.info(
          t(
            "components:keywordsTab.unifiedKeywordsTable.toasts.calculatingScores",
          ),
        );
      }

      return success;
    },
    [product, generateProductKeywords, t],
  );

  return {
    generateKeywords,
    isGenerating,
    errorUpdate,
    errorGenerate,
  };
};
